// Contatos que chegaram pelo formulário do site institucional (somente leitura).
import { Empty, ErrorState, Loading, PageHead } from '../../ui'
import { AdminNav } from '../../features/admin/AdminNav'
import { dateTime, useAdminSiteLeads } from '../../features/admin/api'

const KIND = { business: 'Tenho um negócio', agency: 'Sou agência', other: 'Outro' } as const

export default function AdminSiteLeads() {
  const q = useAdminSiteLeads()
  return (
    <>
      <PageHead title="Contatos do site" sub="Quem preencheu o formulário do site institucional. Mostra os 200 mais recentes." />
      <AdminNav />
      {q.isLoading && <div className="card"><Loading lines={5} /></div>}
      {q.error && <ErrorState error={q.error} onRetry={() => q.refetch()} />}
      {q.data && (q.data.items.length === 0 ? <Empty title="Nenhum contato ainda" /> : (
        <div className="card flush table-wrap">
          <table className="table stack-sm">
            <thead><tr><th>Quando</th><th>Nome</th><th>E-mail</th><th>Perfil</th><th>Mensagem</th></tr></thead>
            <tbody>
              {q.data.items.map((l) => (
                <tr key={l.id}>
                  <td className="small nowrap" data-label="Quando">{dateTime(l.createdAt)}</td>
                  <td className="small" data-label="Nome">{l.name ?? '—'}</td>
                  <td className="small" data-label="E-mail"><a href={`mailto:${l.email}`}>{l.email}</a></td>
                  <td className="small" data-label="Perfil">{KIND[l.kind]}</td>
                  <td className="small" data-label="Mensagem" style={{ maxWidth: 360, overflowWrap: 'anywhere' }}>{l.message ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </>
  )
}
